"use strict";
var React = require('react');
var ReactDOM = require('react-dom');
var assign = require('lodash/assign');
var createContainerQueryMixin_1 = require('./createContainerQueryMixin');
function default_1(WrappedComponent, query, _a) {
    var _b = (_a === void 0 ? {} : _a).propName, propName = _b === void 0 ? 'containerQuery' : _b;
    return React.createClass({
        displayName: "ContainerQuery(" + getDisplayName(WrappedComponent) + ")",
        mixins: [createContainerQueryMixin_1.default(query)],
        defineContainerComponent: function (ref) {
            this.defineContainer(ReactDOM.findDOMNode(ref));
        },
        render: function () {
            var props = assign({ ref: this.defineContainerComponent }, this.props);
            props[propName] = this.state ? this.state.containerQuery : {};
            return React.createElement(WrappedComponent, props);
        }
    });
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = default_1;
function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || 'Component';
}
//# sourceMappingURL=applyContainerQuery.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-container-query/lib/applyContainerQuery.js
 ** module id = 421
 ** module chunks = 0
 **/